import React from 'react';

import { useInView } from 'react-intersection-observer';
import { easeInOut, motion } from 'framer-motion';

export default function AnimatedP({ children, referencja, fontSize, czyZanimowane }) {

    const variants = {
        hidden: { x: '-100%' },
        visible: { x: 0 },
    };

    return (
            <div className="w-[200%] ">
                <motion.div
                    initial="hidden"
                    animate={referencja ? 'visible' : 'hidden'}
                    variants={variants}
                    transition={czyZanimowane ? ({ duration: 1.5, ease: 'anticipate' }) : ({ duration: 0.0, ease: easeInOut }) }
                    className=''
                    style={{fontSize: fontSize}}
                >
                    {children}
                </motion.div>
            </div>
    );

}